import React, { useEffect, useState } from 'react';
import { supabase } from './supabaseClient';

export default function ProfileNotifications() {
  const [user, setUser] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [marking, setMarking] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) setUser(JSON.parse(storedUser));
  }, []);

  useEffect(() => {
    async function fetchNotifications() {
      if (!user) return;
      setLoading(true);
      const { data } = await supabase
        .from('notifications')
        .select('*')
        .eq('user_id', user.id)
        .order('created_at', { ascending: false });
      setNotifications(data || []);
      setLoading(false);
    }
    if (user) fetchNotifications();
  }, [user, marking]);

  const handleMarkAsRead = async (notifId) => {
    setMarking(notifId);
    await supabase
      .from('notifications')
      .update({ is_read: true })
      .eq('id', notifId);
    setMarking(null);
  };

  if (!user) return <div className="container mt-5"><div className="alert alert-warning">You must be logged in to view your notifications.</div></div>;
  if (loading) return <div className="container mt-5 text-center"><div className="spinner-border text-primary" role="status"><span className="visually-hidden">Loading...</span></div></div>;

  return (
    <div className="container mt-5" style={{maxWidth: 900}}>
      <h3 className="mb-4">My Notifications</h3>
      {notifications.length === 0 ? (
        <div className="alert alert-info">No notifications yet.</div>
      ) : (
        <ul className="list-group">
          {notifications.map(n => (
            <li className={`list-group-item d-flex flex-column flex-md-row justify-content-between align-items-md-center ${n.is_read ? '' : 'bg-light'}`} key={n.id}>
              <div>
                <span className="fw-bold text-primary">[{n.type}]</span>
                <span className="ms-2">{n.message}</span>
              </div>
              <div className="d-flex flex-column flex-md-row align-items-md-center gap-2 mt-2 mt-md-0">
                <span className="text-muted small">{new Date(n.created_at).toLocaleString()}</span>
                {!n.is_read && (
                  <button className="btn btn-sm btn-outline-success" disabled={marking === n.id} onClick={() => handleMarkAsRead(n.id)}>
                    {marking === n.id ? 'Marking...' : 'Mark as Read'}
                  </button>
                )}
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
} 